import { Box, Divider } from '@mui/material';

const PostListHeader = ({ left, right, containerSx, cardSx, dividerSx }) => (
  <Box
    sx={{
      position: 'sticky',
      zIndex: 1000,
      display: 'flex',
      ...containerSx,
    }}
  >
    <Box
      sx={{
        backgroundColor: 'white',
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        py: 0,
        px: 2,
        boxSizing: 'border-box',
        flex: '0 0 auto',
        minHeight: 72,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        ...cardSx,
      }}
    >
      {left}
      {left && right && <Divider orientation="vertical" flexItem sx={{ mx: 1, my: 2, ...dividerSx }} />}
      {right}
    </Box>
  </Box>
);

export default PostListHeader;
